import React from 'react';
import '../../App.css';
import { connect } from 'react-redux'
import Category from './category'
import * as accessoriesAction from './../../action/accessoriesAction';
import FeaturedAccessories from './featuredAccessories';
import AccessoriesHeader from '../header/accessoriesHeader';
import Banner from './banner';
import { Utils } from '../../util/utils';
import { apiUrl } from '../../constants/apiUrl';
import api from '../../service/apiService';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import Loader from './../../components/loader';
import { getDTMInit } from './../../service/dtmTag';
import { getVZDLInit } from './../../service/vzdl';
import { updatePageLogs, checktime, catchJSException } from './../../service/logService';
import * as errorAction from './../../action/errorAction';
import * as checkoutAction from './../../action/checkoutAction';
import { Helmet } from "react-helmet";


class Accessories extends React.PureComponent {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    validateVisitid(){
        let server_visitid=window.accid1
        let server_exptime=window.accexp
        if(server_visitid!==undefined && server_visitid!=="" && server_visitid!==this.props.appState.visitId){
            // window.localStorage.setItem('visit_id', server_visitid);
            window.localStorage.setItem('visit_id_vtp', server_visitid);
            // window.localStorage.setItem('expirationTime', server_exptime);
            window.localStorage.setItem('expirationTime_vtp', server_exptime);
            // window.sessionStorage.setItem('visit_id', server_visitid);
            window.sessionStorage.setItem('visit_id_vtp', server_visitid); 
            this.props.dispatch({ type: "UPDATE_VISITID", value: { visitId:server_visitid, visitorId: this.props.appState.visitorId } });
            window.accid1="";
            window.accexp="";
            accessoriesAction.updateProfileCall(false,this.props.dispatch);
        }
    }
    getClientIp(){
        let clientIp = window.accip;
        if(clientIp !== undefined && clientIp !== "" && this.props.appState.clientIp === ""){
            accessoriesAction.updateClientIp(this.props.dispatch, clientIp);
            window.accip="";
        }else {
            window.accip="";
        }
    }
    getAcceptHeader(){
        let acceptHeader = window.acceptheader;        
        if(acceptHeader !== undefined && acceptHeader !== "" && acceptHeader !== null && this.props.appState.acceptHeader === ""){
            accessoriesAction.updateAcceptHeader(this.props.dispatch, acceptHeader);
            window.acceptheader="";
        }else {
            window.acceptheader="";
        }
    }
    createVisitID() {
        try {
            //this.cookie_VisitId = window.localStorage.getItem("visit_id");
            this.cookie_VisitId = window.localStorage.getItem("visit_id_vtp");
            if (this.props.appState.visitId === "" || this.cookie_VisitId === null || this.cookie_VisitId === '') {
                console.log("create visitid invoked from index.js");
                const visitidUrl = apiUrl().createVisitId;
                return new Promise((resolve, reject) => {
                    api(visitidUrl, 'GET', '').then(response => {
                        if (Utils.isNotEmpty(response) && Utils.isNotEmpty(response.visit_id) && Utils.isNotEmpty(response.visitor_id)) {
                            //window.localStorage.setItem('visit_id', response.visit_id);
                            window.localStorage.setItem('visit_id_vtp', response.visit_id);
                            window.localStorage.setItem('visitor_id', response.visitor_id);
                            let expTime = response.expirationTime;
                            if (!expTime && window.location.host.indexOf('localhost') !== -1) {
                                expTime = Date.now() + 86400000 - ((((new Date().getHours()) * 60) + (new Date().getMinutes())) * 60000);
                            }
                            //window.localStorage.setItem('expirationTime', expTime);
                            window.localStorage.setItem('expirationTime_vtp', expTime);
                            //window.sessionStorage.setItem('visit_id', response.visit_id);
                            window.sessionStorage.setItem('visit_id_vtp', response.visit_id);
                        }
                        accessoriesAction.setCookie(this.props.cookies, response, this.props);
                        accessoriesAction.updateProfileCall(false,this.props.dispatch);
                        this.processPageAfterVisitID();
                        resolve(response);
                    })
                        .catch(error => {
                            reject('error-visitidcreation')
                        });
                })
            }
            else
                console.log("createvisitid not invoked");

        } catch (ex) {
            catchJSException('Accessories', "", 'createVisitID', ex);
        }

    }
    processPageAfterVisitID = () => {
        try {
            updatePageLogs(this.props.appState, this.props.appState.visitId, false);
            checktime(this.callCheckTime('Mount'));
            // getDTMInit("checkAvaillqInit", { appInfo: this.props.appState, lqInfo: this.props.lqState });
        }
        catch (ex) {
            catchJSException('visitId_Error', this.props.appState.visitId, 'processPageAfterVisitID', ex);
        }
    }
    callCheckTime = ((pagestate) => {
        return {
            page: 'homepage',
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false
        }
    })
    profilePageLog=()=>{
        if(this.props.categoriesState.isValidUser){
            console.log('categories_validUser')
            checktime(this.validUser('Mount'))
        }else{
            console.log('categories_GuestCustomer')
            checktime(this.notValidUser('Mount'))
        }
    }
    validUser = ((pagestate) => {
        return {
            page: 'categories_ValidUser',
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false,
            apiFetched: (pagestate === 'ApiFetched') && Date.now()
        }
    })
    notValidUser = ((pagestate) => {
        return {
            page: 'categories_GuestCustomer',
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false,
            apiFetched: (pagestate === 'ApiFetched') && Date.now()
        }
    })
    profileCallCheck = ((pagestate,profileCondDataValue) => {
        return {
            page: 'homepage_ProfileCallCondCheck_'+profileCondDataValue,
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false,
            apiFetched: (pagestate === 'ApiFetched') && Date.now()
        }
    })
    iscacherefreshneed = (cachetime) =>
    {
	return (Math.abs((Date.now()) - cachetime) / 36e5) > 24;
    }

    loadScript = (url) => {
        try {
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = url;
            document.body.appendChild(script);
        }
        catch (ex) {
            catchJSException('Accessories', "", 'loadScript', ex);
        }
    }

    injectDDScript = ()=>{
        try{
        document.body.setAttribute("class","kaxsdc");        
        document.body.setAttribute("data-event","load");
        let safetechMerchantId ="300637";
        let sessionId = this.props.appState && this.props.appState.visitId;
        let url="https://tst.kaptcha.com/"; /**for non-prod*/        
        let host = window.location.host;
        if ((host === "www.verizon.com")) {
            url = "https://ssl.kaptcha.com/"; 
        }
        let scriptUrl = url+"collect/sdk?m="+safetechMerchantId+"&s="+sessionId;        
        this.loadScript(scriptUrl);
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerText= `setTimeout(function () {if(typeof ka != 'undefined'){var client=new ka.ClientSDK();client.autoLoadEvents ();}},3000)`;
        document.body.appendChild(script);
        }
        catch (ex) {
            catchJSException('Accessories', "", 'injectDDScript', ex);
        }
    }
    componentWillMount() { 
        if(window.refreshGnav){  
         window.refreshGnav('')
        }
        
        checktime(this.callCheckTime('WillMount'));
        if (Utils.isNotNull(this.props.orderSubmitState) && this.props.orderSubmitState.orderPlaced === "Y") {
            Utils.clearRedux("all");
            //window.localStorage.setItem('visit_id', "");
            window.localStorage.setItem('visit_id_vtp', "");
            window.localStorage.setItem('visitor_id', "");
            //in this case we need to clear the browser cookie as well - which need separate node endpoint to do
            //or simply create new visitid
        }
        this.validateVisitid();
        this.getClientIp();
        this.getAcceptHeader();
        let validatePromise = this.createVisitID();
        Promise.all([validatePromise])
            .then(
                response => {
                    const { cookies } = this.props;
                    let validatePromise
                    let userInfo = cookies.get('userinfo');

                    let oneSSOId = Utils.getCookieByPartialKey('onessoid');
                    let oneV = cookies.get('oneV');
                    console.log("values to check ONEVZ_TO_ACCESSORIES_ROUTE 1",userInfo, oneSSOId, oneV ,this.props.categoriesState.isGuestFlow, this.props.appState.oneVzToAccessoriesRoute)
                    if ((userInfo == undefined || userInfo == "" || userInfo == null) && !this.props.categoriesState.isGuestFlow && ((oneSSOId != undefined && oneSSOId != "" && oneSSOId != null) || ( oneV != undefined && oneV != "" && oneV != null  && oneV =="true")) && !this.props.appState.oneVzToAccessoriesRoute) {
                      this.props.dispatch({ type: 'ONEVZ_TO_ACCESSORIES_ROUTE', value: true});
                      let redirectUrl = apiUrl().myOneVzRoutingUrl ;
                      console.log("ONEVZ_TO_ACCESSORIES_ROUTE 1", redirectUrl)
                      window.location.assign(redirectUrl);
                    }
                    
                    let txnData = {
                        total : this.props.cartData.total,
                        taxAmt : this.props.cartData.tax,
                        shippingZip : "",
                        shippingCharge : this.props.cartData.shippingcrg,
                        paymentType : "",
                        status : ""
                    }
                    let profileCondData={
                        "isUserInfo": (userInfo !== undefined && userInfo !== "" && userInfo !== null) ? true : false,
                        "isProfileCallTriggered": this.props.categoriesState.isProfileCall,
                        "isGuestFlowValue": this.props.categoriesState.isGuestFlow,
                        "isOrderPlaced": ((Utils.isNotNull(this.props.orderSubmitState) && 
                        this.props.orderSubmitState.orderPlaced === "Y"))? true : false
                     } 
                     let profileCondDataValue=JSON.stringify(profileCondData) 
                     checktime(this.profileCallCheck("Mount",profileCondDataValue))
                    //getDTMInit("accessoriesHome", "", "", "", "", "", "", "", transactionData);
                    if(userInfo !== undefined && userInfo !== "" && userInfo !== null && !this.props.categoriesState.isProfileCall  && !this.props.categoriesState.isGuestFlow){
                     validatePromise=checkoutAction.getProfileInfo(this.props.dispatch,this.props.appState.visitId).then(
                        response=>{
                            this.profilePageLog()
                        }
                     )
                        accessoriesAction.updateSigninApplied(true,this.props.dispatch)  
                        accessoriesAction.updateFlowType("AF",this.props.dispatch)          
                    }
                    if(typeof ka == "undefined"){
                        this.injectDDScript(); //Script for Safetech Device Data Collector
                        }
                     accessoriesAction.getbannerFromAPI(this.props.dispatch);
                     accessoriesAction.getCategoriesFromAPI(this.props.dispatch);
                     accessoriesAction.getHeaderContent(this.props.dispatch,this.props.appState.visitId)
                     accessoriesAction.getStandardErrorsFromAPI(this.props.dispatch,this.props.appState.visitId);
                     (this.props.vtpErrors && this.props.vtpErrors.billPunchoutErrors) ? "" : errorAction.getBillPunchOutErrors(this.props.dispatch,this.props.appState.visitId);
                     (this.props.vtpErrors && this.props.vtpErrors.billingAddressValidationErrors) ? "" : errorAction.getBillingAddressValidationErrors(this.props.dispatch,this.props.appState.visitId);
                     (this.props.vtpErrors && this.props.vtpErrors.vzProfileErrors) ? "" : errorAction.getVzProfileErrors(this.props.dispatch,this.props.appState.visitId);
                    //  (this.props.appState && this.props.appState.flowSubtype) ? "" : accessoriesAction.updateFlowSubType("vtp",this.props.dispatch, this.props.appState.visitId);
                     let transactionData = {
                        visitId: this.props.appState.visitId
                    }
                    // getDTMInit("accessoriesHome", "", "", "", "", "", "", "", transactionData);
                    //  getVZDLInit(this.props.appState.visitId,"home","","","","","Accessories","","",{cartData : this.props.cartProduct,txnData : txnData});
                     Promise.all([validatePromise])
                     .then(value=>{
                     let request={
                         "signedIn": this.props.categoriesState.isValidUser,
                         "mlpFlow" : (this.props.appState && this.props.appState.mlpFlow) ? this.props.appState.mlpFlow : false,
                         "redemptionProductName" : (this.props.appState && this.props.appState.mlpPDP) ? this.props.appState.mlpPDP : "",
                      }
                      accessoriesAction.getfeaturedAccessoriesFromAPI(this.props.dispatch,this.props.appState.visitId,JSON.stringify(request));
                      getDTMInit("accessoriesHome", "", "", "", "", "", "", "", transactionData);
                      getVZDLInit(this.props.appState.visitId,"home","","","","","Accessories","","",{cartData : this.props.cartProduct,txnData : txnData});
                    })                    
                    
                    return response;
                }
            )

        // accessoriesAction.getCategoriesFromJSON(this.props.dispatch);

        var vtpFlowType = "FIOS";
        var aimsFlow = "LearnServiceVTP";
        var aimsChatCreditFlow = 1;
        if (vtpFlowType === "FIOS") {
            aimsChatCreditFlow = 1;
        }
        try {
            if (typeof aimsChatCreditFlow !== 'undefined') {
                window.setCustomerInfo('OTHER', aimsChatCreditFlow);
                window.reInit();
            }
        }
        catch (ex) {
            catchJSException('loopQual', this.props.appState.visitId, 'setBannerType', ex);
        }
        if (typeof setExtraCustomerInfo !== 'undefined') {
            window.setExtraCustomerInfo('SOURCE_PAGE', "AccessoriesHome");
            window.setExtraCustomerInfo('other', aimsFlow);
        }        
    }
    // componentDidMount(){
    //     let transactionData = {
    //         visitId: this.props.appState.visitId
    //     }
        
    //         getDTMInit("accessoriesHome", "", "", "", "", "", "", "", transactionData);
        
    // }
    render() {
        // window.refreshGnav('')
        
        let browserUrl;
        if(Utils && Utils.getDomainUrl() && window.location && window.location.pathname){
            browserUrl = Utils.getDomainUrl()+ window.location.pathname ;
           
        }
       
        let metaInfo
            metaInfo = (
                <div >
                    <Helmet>
                    <meta name="keywords" content="fios, fios tv, router, wifi, cables, connectors, networking, network, fios accessories,smart home,fun,fitness"/>
                    <meta name="description" content="Buy Verizon accessories to get the most out of your Verizon experience. Shop for your Fios TV remote control, phone charger, router &amp; Wifi"/>
                    {browserUrl && ( <link  rel="canonical" href={browserUrl}/>
                    )}
                    </Helmet>
                </div>
            )
        
        let featuredAccessoriesExp
        let bannerExp

        // if (this.props.categoriesState && this.props.categoriesState.featuredAccessoriesExp) {
             featuredAccessoriesExp = this.props.categoriesState.featuredAccessoriesExp
            bannerExp = this.props.categoriesState.bannerExp
        // }
        let category = <Category appState={this.props.appState} categoriesValue={this.props.categoriesState} props={this.props} />;
        let featuredAccessories = <FeaturedAccessories appState={this.props.appState} featuredAccessoriesValue={featuredAccessoriesExp} categoriesState={this.props.categoriesState} props={this.props} />
        let accessoriesHeader = <AccessoriesHeader accessoriesHeaderValue={this.props.categoriesState} props={this.props}></AccessoriesHeader>
        let banner = <Banner bannerValue={bannerExp} props={this.props} />
        return (
            <div className="App bg-white ">
                {metaInfo}
                <Loader />
                {accessoriesHeader}
                <main>
                {banner}               
                <div className="store-front-container">
                    {category}
                </div>
                <div className="featured-accessories " >
                    {featuredAccessories}
                </div>
                <div className="margin-bottom-large clear">&nbsp;</div>
                <div className="margin-bottom-large clear">&nbsp;</div>
                </main>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        appState: state.appVTP,
        categoriesState: state.categoriesVTP,
        cartProduct: state.cartProductDataVTP.cartProduct,
        cartData : state.cartProductDataVTP,
        orderSubmitState: state.orderSubmitVTP,
        vtpErrors : state.errorVTP
    }
}


// export default (connect(
//     mapStateToProps
// )(Accessories));
//export default Accessories;

export default withCookies(connect(
    mapStateToProps
)(Accessories));